import store from '@/store/index';
import { mapActions } from 'vuex';
import { MODALS } from '@/components/app/app-modals/modals-constants';
import { STATIC_PAGES } from '@/constants';
import cmsContentMixin from '@/mixins/cmsContent';
import loaderMixin from '@/mixins/loader';
import contentLoaderMixin from '@/mixins/contentLoader';
import staticPageHeader from '@/components/static-page-header/static-page-header.vue';

let toRoute = '';
let restore = true;

export default {
  mixins: [
    cmsContentMixin,
    loaderMixin,
    contentLoaderMixin,
  ],
  components: {
    staticPageHeader,
  },
  metaInfo() {
    return {
      title: 'Privacy Policy',
    };
  },
  data() {
    return {
      content: '',
    };
  },
  methods: {
    ...mapActions('browse', ['getStaticPageFull']),
  },
  created() {
    this.loaderAdd(document.body);
    this.getStaticPageFull(STATIC_PAGES.PRIVACY)
      .then((data) => {
        this.isComponentReady = true;
        this.installDynamicControls({ data });
      })
      .then(() => this.loaderRemove(document.body))
      .catch(() => this.loaderRemove(document.body));
  },
  // beforeDestroy() {
  //   // firest after router loop
  //   if (restore) {
  //     store.dispatch('popup/restorePopup', toRoute);
  //   }
  // },
  beforeRouteEnter(to, from, next) {
    const popup = to.params.noPopup ? null : MODALS.ACCOUNT_VERIFY;
    store.dispatch('popup/rememberPopup', {
      route: from.name,
      popup,
    });
    next();
  },
  beforeRouteLeave(to, from, next) {
    // fires before router loop closes popup
    restore = to.name !== 'terms-and-conditions';
    toRoute = to.name;
    next();
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-privacy-policy/page-privacy-policy.js